import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuthCon from "../composant_reutilisable/useAthCon";
import LoadingSpinner from "../composant_reutilisable/loading";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Modal, Button, Form } from 'react-bootstrap';

const ResetPassword = (show, onHide, onSend) => {
    const { token } = useParams(); // Récupère le token dans l'URL
    console.log("Token reçu :", token);
    // useAuthCon();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({ email: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [alert, setAlert] = useState({ message: "", type: "" });

    const [password, setPassword] = useState("");
    const [password1, setPassword1] = useState("");
    const [loading, setLoading] = useState(false);

    // Gérer la saisie des champs
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Affichage des alertes
    const showAlert = (message, type = "danger") => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: "", type: "" });
        }, 5000);
    };

    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setAlert({ message: '', type: '' });
    };


    // Gérer l'envoi du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== password1) {
            showAlert("Les mots de passe ne correspondent pas.");
            return;
        }

        setLoading(true);
        showAlert("");

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/reinitialiser-mot-de-passe/${token}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ password }),
            });

            const data = await response.json();

            if (data.success) {
                showAlert("Mot de passe réinitialisé avec succès.");
                setTimeout(() => navigate("/connexion"), 2000); // redirection après succès
            } else {
                showAlert(data.message || "Une erreur est survenue.");
            }
        } catch (error) {
            showAlert("Erreur de connexion au serveur.");
        }

        setLoading(false);
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        const response = await fetch(`${process.env.REACT_APP_HOTE}/mot-de-passe-oublie/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();
        if (response.ok) {
            setShowModal(false);
            showAlert("Un nouveau mot de passe a été envoyé à votre adresse email.", 'success');

        } else {
            setShowModal(false);
            showAlert(data.message || "Une erreur est survenue.");

        }
    };

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div
                    className="loginColumns animated fadeInDown"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                    }}
                >
                    <div className="ibox" style={{ width: "100%", maxWidth: "400px" }}>
                        <div className="ibox-content">
                            <h3 className="text-center">
                                <strong>Réinitialisation</strong>
                            </h3>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                            )}

                            <form role="form" className="p-2" onSubmit={handleSubmit}>
                                <div className="form-group mb-0">
                                    <label className="col-form-label">Nouveau mot de passe</label>
                                    <div className="">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Entrez votre mot de passe"
                                            className="form-control pe-5"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group ">
                                    <label className=" col-form-label">Confirmer Mot de passe</label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password1"
                                            placeholder="Entrez votre mot de passe"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword1(e.target.value)}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "15px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <button
                                        className="btn btn-sm btn-success col-md-12 mb-2"
                                        type="submit"
                                    >
                                        <strong>Changer</strong>
                                    </button>

                                    {/* <button
                                        className="btn btn-outline btn-success col-md-12"
                                        type="button"
                                        onClick={handleInscription}
                                    >
                                        <strong>Inscription</strong>
                                    </button> */}
                                </div>
                                {/* <p>
                                    <span
                                        className="mt-1"
                                        onClick={(handleOpenModal)}
                                        style={{ cursor: "pointer", color: "blue" }}
                                    >Mot de passe oublié ?</span>
                                </p> */}

                            </form>
                        </div>
                        <div className="row">
                            <div class="col-md-12 w-100 text-center">
                                <small><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer">ADN Services</a> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer">INOVACT SARL</a></small>
                            </div>
                        </div>

                        <Modal show={showModal} onHide={handleCloseModal} centered>
                            <Modal.Header>
                                <Modal.Title>Réinitialiser le mot de passe</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group controlId="email">
                                        <Form.Label>Votre email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Entrer votre email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    {message && (
                                        <div className="mt-3">
                                            <small className="text-muted">{message}</small>
                                        </div>
                                    )}
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseModal}>
                                    Fermer
                                </Button>
                                <Button variant="success" onClick={handleResetPassword}>
                                    Reinitialiser
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            )}
        </>
    );
};

export default ResetPassword;

